/**
 * Сохраняет URL для редиректа после авторизации
 */
export function saveRedirectUrl(url: string) {
  if (url && url !== '/' && !url.includes('/auth')) {
    sessionStorage.setItem('auth_redirect_url', url)
  }
}

/**
 * Получает и очищает сохранённый URL для редиректа
 */
export function getAndClearRedirectUrl(): string | null {
  const url = sessionStorage.getItem('auth_redirect_url')
  sessionStorage.removeItem('auth_redirect_url')
  return url
}
